import types from './types';

const setActiveCustomFilter = (activeCustomFilterState, activeCustomFilter) => ({
  type: types.SET_ACTIVE_CUSTOM_FILTER,
  payload: {
    activeCustomFilterState,
    activeCustomFilter
  }
});


const setCustomFilters = (customFilters) => ({
  type: types.SET_CUSTOM_FILTERS,
  payload: {
    customFilters
  }
});


/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setActiveCustomFilter,
  setCustomFilters
};
